export default "__VITE_ASSET__DSq8x7wA__"